import * as React from 'react';

import * as Icons from '../../../icons';
import { Styled } from './styled';

export const EditButton = (props) => {
  const { onClick } = props;
  return (
    <Styled.Container onClick={onClick}>
      <Icons.Edit2D />
    </Styled.Container>
  );
};
